import { includes } from 'lodash'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Form } from 'semantic-ui-react'
import { CurrencyEnum } from '../../containers/TradeForm/Types'
import HelperTextLabel from '../HelperTextLabel'
import styles from './styles.module.less'

export interface DollarBlurEvent {
  target: { name: string }
}

export interface DollarInputProps {
  className?: string
  error?: { content: string } | null
  helpText?: string
  name: string
  label: string
  onBlur?: (e: DollarBlurEvent) => void
  onChange: (inputId: string, newValue?: number) => void
  value?: number
  currency: CurrencyEnum
}

const DollarInput = ({
  className,
  currency,
  error,
  helpText,
  label,
  name,
  onBlur,
  onChange,
  value,
}: DollarInputProps) => {
  const formatter = useIntl()
  const [enteringData, setEnteringData] = useState(false)

  const handleBlur = (e: DollarBlurEvent) => {
    setEnteringData(false)
    onBlur && onBlur(e)
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEnteringData(true)
    const numericValue: number = parseFloat(event.target.value)
    onChange(name, isNaN(numericValue) ? undefined : numericValue)
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    if (includes(['ArrowUp', 'ArrowDown'], event.key)) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  const formattedValue =
    value !== undefined
      ? enteringData || error
        ? value
        : formatter
            .formatNumber(value, {
              style: 'decimal',
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              minimumIntegerDigits: 1,
            })
            .replace(/,/gi, '')
      : ''

  return (
    <div className={`dollar-input ${styles.dollarInput} ${error ? styles.error : ''}`}>
      <label className={`label ${styles.inputLabel}`}>
        <HelperTextLabel label={label} helperText={helpText} />
      </label>
      <div className="ui right labeled input">
        <label htmlFor={name} className={`ui label ${styles.dollarLabel}`}>
          {currency === CurrencyEnum.cad ? 'CA$' : '$'}
        </label>
        <Form.Input
          aria-label={label}
          className={className}
          error={error}
          name={name}
          onBlur={handleBlur}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="0.00"
          type="number"
          value={formattedValue}
        />
      </div>
    </div>
  )
}

export default DollarInput
